import Api from './axios';

/**
 * Upload documents to a specific building unit
 * @param {FormData} formData - Form data containing files and metadata
 * @returns {Promise} - API response
 */
export const uploadDocuments = async (formData) => {
  return await Api.post("/v1/unit/documents", formData);
};

/**
 * Get documents for a specific unit
 * @param {string} unitId - ID of the unit
 * @param {Object} params - Optional query parameters (pagination, filters, etc.)
 * @returns {Promise} - API response with unit documents
 */
export const getUnitDocuments = async (unitId, params = {}) => {
  return await Api.get(`/v1/unit/${unitId}/documents`, { params });
};

export const updateDocumentTitle = async ({document_id, data}) => {
  return await Api.put(`/v1/unit/documents/${document_id}`, data, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

export const deleteDocument = async ({id, unit_id}) => {
  return await Api.delete(`/v1/unit/documents/${id}?unit_id=${unit_id}`);
};